import Dexie from "dexie";
import moment from "moment";

const db = new Dexie('CCloud');

db.version(1).stores({
  summaries: '++id,detail,createdTime,updatedTime,isDeleted',
});

const DATETIME_FORMAT = "YYYY-MM-DD hh:mm:ss";

export default class {
  static async getSummaries(){
    try {
      return await db.summaries.toArray();
    } catch (error) {
      console.log(error);
    }
  }

  static async getSummary(id){
    try {
      return await db.summaries.get(id);
    } catch (error) {
      console.log(error);
    }
  }

  static async addSummary(summary){
    try {
      return await db.summaries.add({
        createdTime: moment().format(DATETIME_FORMAT),
        updatedTime: moment().format(DATETIME_FORMAT),
        isDeleted: false,
        ...summary
      });
    } catch (error) {
      console.log(error);
    }
  }

  static async updateSummary(summary){
    try {
      await db.summaries.update(summary.id, {
        ...summary,
        updatedTime: moment().format(DATETIME_FORMAT),
      });
    } catch (error) {
      console.log(error);
    }
  }

  static async deleteSummary(summary){
    try {
      await db.gaits.delete(summary.id);
    } catch (error) {
      console.log(error);
    }
  }
}


